import { render, staticRenderFns } from "./imageLibrary.vue?vue&type=template&id=39c585ae&scoped=true"
import script from "./imageLibrary.vue?vue&type=script&lang=js"
export * from "./imageLibrary.vue?vue&type=script&lang=js"
import style0 from "./imageLibrary.vue?vue&type=style&index=0&id=39c585ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c585ae",
  null
  
)

export default component.exports